export const SCENE_DOM_NAME = 'canvas'
